import { connect } from 'react-redux';
import find from 'lodash/fp/find';
import WindowNotes from './WindowNotes';

const mapDispatchToProps = undefined;

const mapStateToProps = ({
  estimateBuilder:
  {
    entities: { items },
  },
}, ownProps) => {
  const {
    attributes: itemAttributes,
  } = items.byId[ownProps.itemId];

  let notes = [];
  if (find({ name: 'notes' })(itemAttributes)) {
    const notesArray = find({ name: 'notes' })(itemAttributes).value || '[]';
    notes = JSON.parse(notesArray);
  }
  return {
    notes,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WindowNotes);
